module.exports = __webpack_public_path__ + "img/maja-ser-det-fede-3.e8a9d3ca.png";